import { useLocation } from 'react-router'
import { setGTADataLayer } from 'shared/util/analytics'
import { fromPathname } from 'shared/util/ga-category'

const GTALogger = () => {
    const { pathname }: Partial<Location> = useLocation()
    const value = fromPathname(pathname)
    if (value) {
        setGTADataLayer({ dimension: 'PageCategory', value })
    }
    return null
}

export default GTALogger
